import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-payment-header',
    templateUrl: './payment-header.component.html',
    standalone: false
})
export class PaymentHeaderComponent implements OnInit {
  @Input() selectedHeader: string;
  @Input() tableCategory: string;
  constructor() {}

  ngOnInit(): void {}
}
